var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.501,
    y1: -0.807,
    x2: 0.501,
    y2: 1.017,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8533eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00c9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f06b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.499,
    y1: -0.841,
    x2: 0.499,
    y2: 1.017,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: -0.017,
    x2: 0.5,
    y2: 1.53,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.295 -0.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.69,23.97h-.05a.521.521,0,0,1-.4-.27l-4.18-8.17a.505.505,0,1,1,.9-.46l3.83,7.48,2.03-2.5a.515.515,0,0,1,.36-.19l3.22-.18-4.28-8.37a.505.505,0,1,1,.9-.46l4.63,9.06a.51.51,0,0,1-.01.48.493.493,0,0,1-.41.25l-3.77.21-2.38,2.93a.508.508,0,0,1-.39.19Z",
    transform: "translate(0.59 0.06)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31,23.97a.493.493,0,0,1-.39-.19L4.54,20.85.77,20.64a.485.485,0,0,1-.41-.25.51.51,0,0,1-.01-.48l4.5-8.81a.505.505,0,1,1,.9.46L1.6,19.68l3.22.18a.48.48,0,0,1,.36.19l2.03,2.5,3.75-7.33a.505.505,0,0,1,.9.46L7.76,23.7a.521.521,0,0,1-.4.27H7.31Z",
    transform: "translate(0 0.06)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.165,15.83A8.062,8.062,0,0,1,3.97,7.93,8.069,8.069,0,0,1,12.165.03a8.069,8.069,0,0,1,8.195,7.9,8.062,8.062,0,0,1-8.195,7.9Zm0-14.79A7.029,7.029,0,0,0,5.018,7.93a7.029,7.029,0,0,0,7.147,6.89,7.029,7.029,0,0,0,7.147-6.89A7.022,7.022,0,0,0,12.165,1.04Z",
    fill: "url(#c)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate3);
export default __webpack_public_path__ + "static/media/certificate3.9b7ff876c60654ff584bf0a1f6b8a046.svg";
export { ForwardRef as ReactComponent };